var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13.99,
    viewBox: "0 0 19 13.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5870",
    "data-name": "Group 5870",
    transform: "translate(-1361 -604.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6453",
    "data-name": "Caminho 6453",
    d: "M15.5,22.99a10.009,10.009,0,0,1-9.3-6.021,2.518,2.518,0,0,1,0-1.948A10.009,10.009,0,0,1,15.5,9a10.009,10.009,0,0,1,9.3,6.021,2.518,2.518,0,0,1,0,1.948A10.009,10.009,0,0,1,15.5,22.99Zm0-12.824a8.823,8.823,0,0,0-8.207,5.3,1.365,1.365,0,0,0,0,1.056,8.824,8.824,0,0,0,8.207,5.3,8.823,8.823,0,0,0,8.207-5.3,1.363,1.363,0,0,0,0-1.055,8.823,8.823,0,0,0-8.207-5.3Z",
    transform: "translate(1355 595.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6454",
    "data-name": "Caminho 6454",
    d: "M17.125,20.25a3.125,3.125,0,1,1,3.125-3.125A3.128,3.128,0,0,1,17.125,20.25Zm0-5.078a1.953,1.953,0,1,0,1.953,1.953A1.956,1.956,0,0,0,17.125,15.172Z",
    transform: "translate(1353.375 593.872)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisabled);
export default __webpack_public_path__ + "static/media/eyeDisabled.a1fde822f8e639842a9efc3eab8cc61f.svg";
export { ForwardRef as ReactComponent };